import {swalWarningFire} from "../../plugins/sweet-alert/sweet-alert-default";

export default function validateAdditionalQuestionsCount($context) {
    const targetTemplateId = $context.data('target-id');
    const $list = $(`#${targetTemplateId}`);
    const questionsCount = $list.children('.question-item').length;
    const limitQuestionsCount = $('#company-max-questions-count').val();
    if (questionsCount >= limitQuestionsCount) {
        swalWarningFire({
            title: 'Limit on the number of questions',
            text: 'You have already used up the allowed number of questions.',
        });

        return false;
    }

    return true;
}
